import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
export const StyledBoxSubtitle = styled(BoxSubtitle)`
    ${setFontVariant("value", colorsPalettes.carbon[400])};
    margin-left: 16px;
`;
